import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';

interface IProps {
	changeTaxPercent: (value: Nullable<number>) => void;
	isTaxPercentProtectedFromSync: boolean;
}

export const TaxPercent: React.FC<IProps> = React.memo(({ changeTaxPercent, isTaxPercentProtectedFromSync }) => {
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterTaxRate') }], [t]);

	return (
		<>
			{isTaxPercentProtectedFromSync && (
				<FormInput
					testId="TaxPercent"
					type="number"
					min={0}
					max={100}
					precision={1}
					name="taxPercent"
					label="taxRateLabel"
					onChangeNumber={changeTaxPercent}
					validationRules={validationRules}
				/>
			)}
		</>
	);
});
